/* React - Redux libraries */
// nonprod pipeline smoke test (trivial, no behavior change) -- confirms OIDC deploy end to end
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { makeStyles, ThemeProvider } from "@material-ui/core";
import theme from "resources/theme";
import * as Sentry from "@sentry/react";
import {
  REACT_APP_ENV,
  REACT_APP_BITBUCKET_BUILD_NUMBER,
  REACT_APP_SENTRY_URL,
  REACT_APP_BASE_URL,
} from "resources/constants";
import { Integrations } from "@sentry/tracing";
/* Own libraries */
import store from "redux_setup/store";
import App from "App";
import "index.css";
import "typeface-lato";
import history from "app/history";

const useStyles = makeStyles(() => ({
  snackRoot: {
    paddingTop: "8px",
    paddingBottom: "8px",
    maxWidth: "500px",
  },
  snackAction: {
    /*
    This prevents the action buttons defined in snackbars from
    being slightly closer to the edge than the opposite side of
    the snackbar, i.e. the margin at both sides of the snackbar is
    the same
    */
    marginRight: 0,
  },
}));

function WrappedApp() {
  const classes = useStyles();

  return (
    <Provider store={store}>
      <Router history={history}>
        <ThemeProvider theme={theme}>
          {/* SnackbarProvider must be contained inside the MUI ThemeProvider 
          so that it does not override the theme styles */}
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            classes={{
              contentRoot: classes.snackRoot,
              action: classes.snackAction,
            }}
          >
            <App />
          </SnackbarProvider>
        </ThemeProvider>
      </Router>
    </Provider>
  );
}
if (REACT_APP_ENV !== undefined) {
  Sentry.init({
    dsn: REACT_APP_SENTRY_URL,
    environment: REACT_APP_BASE_URL.includes("customer")
      ? `arma-${
          REACT_APP_SENTRY_URL === "production" ? "prod" : REACT_APP_SENTRY_URL
        }-customer`
      : `arma-${
          REACT_APP_SENTRY_URL === "production" ? "prod" : REACT_APP_SENTRY_URL
        }-preview`,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    release: REACT_APP_BITBUCKET_BUILD_NUMBER,
    integrations: [
      new Integrations.BrowserTracing(),
      new Sentry.Replay({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
  Sentry.configureScope((scope) => {
    scope.setExtra("sessionURL", "");
  });
}
ReactDOM.render(<WrappedApp />, document.getElementById("root"));
